"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggerLevels = void 0;
var LoggerLevels;
(function (LoggerLevels) {
    LoggerLevels["Error"] = "error";
    LoggerLevels["Warn"] = "warn";
    LoggerLevels["Info"] = "info";
    LoggerLevels["Verbose"] = "verbose";
    LoggerLevels["Debug"] = "debug";
    LoggerLevels["Silly"] = "silly";
    LoggerLevels["Silent"] = "silent";
})(LoggerLevels = exports.LoggerLevels || (exports.LoggerLevels = {}));
//# sourceMappingURL=LoggerLevels.js.map